import CitySEOHead from "@/components/feature/CitySEOHead";
import PortStLucieHeroSection from "./components/HeroSection";
import PortStLucieStickyNav from "./components/StickyNav";
import PortStLucieProcessingTimeSection from "./components/ProcessingTimeSection";
import PortStLucieServicesSection from "./components/ServicesSection";
import PortStLucieLocalAreaSection from "./components/LocalAreaSection";
import PortStLucieTravelTimingSection from "./components/TravelTimingSection";
import PortStLucieDestinationsSection from "./components/DestinationsSection";
import PortStLucieTestimonialsSection from "./components/TestimonialsSection";
import PortStLucieAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PortStLucieComparisonSection from "./components/ComparisonSection";
import PortStLucieMistakesSection from "./components/MistakesSection";
import PortStLucieHowItWorksSection from "./components/HowItWorksSection";
import PortStLucieFAQSection, { faqs } from "./components/FAQSection";
import PortStLucieHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PortStLucieFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Port St. Lucie, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Port St. Lucie, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Treasure Coast golfers, retirees, families, and travelers.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PortStLuciePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Port St. Lucie"
        state="Florida"
        stateAbbr="FL"
        route="/cities/port-st-lucie"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Port St. Lucie, Florida"
        geoPosition="27.2730;-80.3582"
        keywords="expedited passport Port St. Lucie, emergency passport Port St. Lucie FL, same day passport Port St. Lucie, fast passport Florida, passport renewal Port St. Lucie, Treasure Coast passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <PortStLucieHeroSection />
      <PortStLucieStickyNav />
      <PortStLucieProcessingTimeSection />
      <PortStLucieServicesSection />
      <PortStLucieLocalAreaSection />
      <PortStLucieTravelTimingSection />
      <PortStLucieDestinationsSection />
      <PortStLucieTestimonialsSection />
      <PortStLucieAcceptanceFacilitiesSection />
      <PortStLucieComparisonSection />
      <PortStLucieMistakesSection />
      <PortStLucieHowItWorksSection />
      <PortStLucieFAQSection />
      <PortStLucieHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/port-st-lucie" state="FL" />
      <PortStLucieFinalCTA />
    </div>
  );
}